
import type { Course } from "~/models/course";
import CourseCard from "./course-card";

interface Props {
    course: Course
}

export default function CourseItem({ course }: Props){
    return(
        <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
            <CourseCard course={course} />
        </div>
    );
}